<template>
  <div class="home">
    <Hero />
    <About />
    <Advantages />
    <Services />
    <Compliance />
<!--    <Clients />-->
    <Career />
    <Contact />
  </div>
</template>

<script setup>
import Hero from '../components/Hero.vue'
import About from '../components/About.vue'
import Advantages from '../components/Advantages.vue'
import Services from '../components/Services.vue'
import Compliance from '../components/Compliance.vue'
// import Clients from '../components/Clients.vue'
import Career from '../components/Career.vue'
import Contact from '../components/Contact.vue'
</script>
